var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7556:114625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 4.51562V0H2.92188C2.48027 0 2.125 0.355273 2.125 0.796875V16.2031C2.125 16.6447 2.48027 17 2.92188 17H14.0781C14.5197 17 14.875 16.6447 14.875 16.2031V5.3125H10.3594C9.92109 5.3125 9.5625 4.95391 9.5625 4.51562ZM11.6875 12.3516C11.6875 12.5707 11.5082 12.75 11.2891 12.75H5.71094C5.4918 12.75 5.3125 12.5707 5.3125 12.3516V12.0859C5.3125 11.8668 5.4918 11.6875 5.71094 11.6875H11.2891C11.5082 11.6875 11.6875 11.8668 11.6875 12.0859V12.3516ZM11.6875 10.2266C11.6875 10.4457 11.5082 10.625 11.2891 10.625H5.71094C5.4918 10.625 5.3125 10.4457 5.3125 10.2266V9.96094C5.3125 9.7418 5.4918 9.5625 5.71094 9.5625H11.2891C11.5082 9.5625 11.6875 9.7418 11.6875 9.96094V10.2266ZM11.6875 7.83594V8.10156C11.6875 8.3207 11.5082 8.5 11.2891 8.5H5.71094C5.4918 8.5 5.3125 8.3207 5.3125 8.10156V7.83594C5.3125 7.6168 5.4918 7.4375 5.71094 7.4375H11.2891C11.5082 7.4375 11.6875 7.6168 11.6875 7.83594ZM14.875 4.04746V4.25H10.625V0H10.8275C11.04 0 11.2426 0.0830078 11.392 0.232422L14.6426 3.48633C14.792 3.63574 14.875 3.83828 14.875 4.04746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7556:114625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.75,
    height: 17,
    fill: "white",
    transform: "translate(2.125)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddInvoice);
export default __webpack_public_path__ + "static/media/IconAddInvoice.45f4b0ef.svg";
export { ForwardRef as ReactComponent };